const BACKEND_PREFIXES = [
  "/admin",
  "/partner",
  "/account",
  "/glemt-adgangskode",
  "/nulstil-adgangskode",
  "/lead-status",
  "/feedback",
];

export function isBackendPath(pathname: string | null | undefined): boolean {
  if (!pathname) return false;
  // Token-based customer resource pages live at /tilbud/:token (+ /tak,
  // /valgt) — no marketing chrome while the customer is mid-decision; noindex
  // is set on page metadata. The wizard root (exact /tilbud) keeps chrome,
  // hence subpaths only.
  if (pathname.startsWith("/tilbud/")) return true;
  return BACKEND_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}
